<template>
  <div class="dashboard">
    <van-nav-bar class="navbar" :title="currentTitle" />
    <div class="fullPage">
      <div class="container-wrapper">
        <!-- 顶部区域 -->
        <div class="search-header">
          <!-- 选项区域 -->
          <div class="header_sift">
            <div class="filtrate">
              <div class="fit_item">
                <!-- 订单状态 -->
                <picker-selector
                  v-model="parameter.supplementOrderType"
                  :options="StatusData"
                  :show-search="false"
                  placeholder="全部"
                  @change="searchCriteria"
                />
              </div>
              <div class="fit_item">
                <picker-selector
                  v-model="parameter.productId"
                  :options="allProducts"
                  placeholder="产品"
                  @change="handleProductSelect"
                />
              </div>
              <div class="fit_item">
                <picker-selector
                  v-model="parameter.advertiserId"
                  :options="allAdvert"
                  search-mode="account"
                  placeholder="账户"
                  @change="handleAdvertSelect"
                />
              </div>
              <div class="fit_item">
                <!-- 订单类型 -->
                <picker-selector
                  v-model="parameter.createType"
                  :options="OrderType"
                  :show-search="false"
                  placeholder="全部"
                  @change="searchCriteria"
                />
              </div>
            </div>
            <div class="fittles">
              <van-icon name="filter-o" @click="showMoreFilters = true" />筛选
            </div>
          </div>

          <!-- 排序栏 -->
          <div class="sort-bar">
            <div
              class="sort-item"
              v-for="item in sortOptions"
              :key="item.field"
              :class="{ active: currentSort.field === item.field }"
              @click="handleSort(item.field)"
            >
              <span>{{ item.label }}</span>
              <span class="sort-icon" v-if="item.field">
                <!-- 升序箭头 -->
                <img
                  :src="
                    currentSort.field === item.field &&
                    currentSort.order === 'asc'
                      ? require('@/assets/images/asc_btn.png')
                      : require('@/assets/images/asc.png')
                  "
                  alt=""
                />
                <!-- 降序箭头 -->
                <img
                  :src="
                    currentSort.field === item.field &&
                    currentSort.order === 'desc'
                      ? require('@/assets/images/desc_btn.png')
                      : require('@/assets/images/desc.png')
                  "
                  alt=""
                />
              </span>
            </div>
          </div>

          <!-- 吸顶区域--指标操作栏 -->
          <van-sticky :offset-top="offsetTop">
            <div class="ceiling">
              <div class="action-buttons">
                <van-button
                  v-if="parameter.supplementOrderType == '7'"
                  @click="handelCancelSend"
                  style="background: #415a7d"
                >
                  取消发送
                </van-button>
                <template v-else>
                  <van-button
                    :disabled="parameter.supplementOrderType !== '1'"
                    @click="handleActions('budget')"
                  >
                    预算
                  </van-button>
                  <van-button
                    :disabled="
                      !(
                        parameter.supplementOrderType === '1' &&
                        parameter.deepUnitChargeType
                      )
                    "
                    @click="handleActions('quote')"
                  >
                    出价
                  </van-button>

                  <van-button
                    :disabled="parameter.supplementOrderType !== '1'"
                    @click="handleActions('time')"
                  >
                    投放时间
                  </van-button>
                  <van-button
                    :disabled="parameter.supplementOrderType !== '1'"
                    @click="handleResultBoost"
                  >
                    结束
                  </van-button>
                  <van-button @click="handleActions('copy')">复制</van-button>
                </template>
              </div>
              <div class="selection-status">
                <!-- <Select
                  v-model="parameter.deepUnitChargeType"
                  @change="searchCriteria"
                  placeholder="请选择"
                >
                  <option value="0">无</option>
                  <option value="7">自然日次日留存</option>
                  <option value=" ">取消</option>
                </Select> -->
                <selector-dropdown
                  v-model="parameter.deepUnitChargeType"
                  :options="optGoal"
                  placeholder="请选择"
                  :clear-on-cancel="true"
                  @change="searchCriteria"
                  style="width: 100px"
                />

                <div style="display: flex; align-items: center">
                  <span style="margin-right: 5px">
                    已选择{{ selectedCount }}条
                  </span>
                  <van-checkbox
                    v-model="onAll"
                    shape="square"
                    icon-size="16px"
                    @change="handelselectAll"
                    :disabled="getSelectableCount() === 0"
                  >
                    全选
                  </van-checkbox>
                </div>
              </div>
            </div>
          </van-sticky>
        </div>

        <!-- 列表内容 -->
        <div class="list-scroll-area">
          <van-list v-model="loading" :finished="finished">
            <van-swipe-cell
              v-for="(item, index) in list"
              :key="index"
              :class="[
                {
                  selected: selectedItems.includes(item.supplementOrderId),
                },
                { 'system-create': item.createType == '系统创建' },
              ]"
            >
              <div
                class="booster-item"
                :class="{ disabled: item.createType == '系统创建' }"
                @click="
                  item.createType !== '系统创建' &&
                    toggleSelect(item.supplementOrderId)
                "
              >
                <div class="item-header">
                  推广剩余时间：{{ formatRemainingTime(item.remainingDate) }}
                </div>
                <div class="item-stats">
                  <span>产: {{ item.productName }}</span>
                  <span>达: {{ item.starName }}</span>
                  <span>助: {{ item.supplementOrderId }}</span>
                  <span>星: {{ item.orderId }}</span>
                </div>
                <div class="special-time">
                  <span>预: {{ item.amount }}</span>
                  <span>出: {{ item.unitPrice }}</span>
                  <span>消: {{ item.consumeAmount }}</span>
                  <span>激: {{ item.conversion }}</span>
                  <span>转: {{ item.conversionCost }}</span>
                </div>
              </div>
              <template #right>
                <van-button
                  square
                  type="danger"
                  text="查看详情"
                  @click="viewDetails(item)"
                  style="background: #fd7014"
                />
                <!-- <van-button
              square
              type="primary"
              text="复制"
              @click.stop="copyItem(item)"
              style="background: #2f89fc"
            /> -->
                <van-button
                  square
                  type="info"
                  text="修改出价"
                  @click.stop="
                    item.createType !== '系统创建' &&
                      handleModifyBid('quote', item)
                  "
                  :class="{ 'button-disabled': item.createType === '系统创建' }"
                  style="background: #3bb873"
                />
              </template>
            </van-swipe-cell>
          </van-list>
        </div>
      </div>

      <!-- 页码分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-controls">
          <span :class="{ disabled: parameter.pageNo === 1 }" @click="prevPage">
            &lt;
          </span>
          <span class="page-info">
            {{ parameter.pageNo }} / {{ totalPages }}
          </span>
          <span
            :class="{ disabled: parameter.pageNo === totalPages }"
            @click="nextPage"
          >
            &gt;
          </span>
        </div>
        <select v-model="parameter.pageSize" @change="handlePageSizeChange">
          <option
            v-for="size in [20, 50, 100, 200, 500]"
            :key="size"
            :value="size"
          >
            {{ size }}条/页
          </option>
        </select>
      </div>
    </div>

    <!-- 更多筛选弹窗 -->
    <van-popup
      v-model="showMoreFilters"
      position="bottom"
      class="filter-popup"
      :style="{ height: '75%' }"
    >
      <div class="filter-header">全部筛选</div>

      <div class="filter-content">
        <van-cell title="投放剩余时间">
          <div slot="default" class="range-inputs">
            <van-field
              v-model="remainingTimeMin"
              type="number"
              placeholder="最小值"
            />
            <span>~</span>
            <van-field
              v-model="remainingTimeMax"
              type="number"
              placeholder="最大值"
            />

            <selector-dropdown
              class="advert"
              v-model="invest"
              :cancelText="''"
              :options="option1"
            />
          </div>
        </van-cell>

        <van-cell title="消耗">
          <div slot="default" class="range-inputs">
            <van-field
              v-model="parameter.consumeAmountMin"
              type="number"
              placeholder="最小值"
              @blur="validateRange('consumeAmountMin', 'consumeAmountMax')"
            />
            <span>~</span>
            <van-field
              v-model="parameter.consumeAmountMax"
              type="number"
              placeholder="最大值"
              @blur="validateRange('consumeAmountMin', 'consumeAmountMax')"
            />
          </div>
        </van-cell>

        <van-cell title="出价">
          <div slot="default" class="range-inputs">
            <van-field
              v-model="parameter.unitPriceMin"
              type="number"
              placeholder="最小值"
              @blur="validateRange('unitPriceMin', 'unitPriceMax')"
            />
            <span>~</span>
            <van-field
              v-model="parameter.unitPriceMax"
              type="number"
              placeholder="最大值"
              @blur="validateRange('unitPriceMin', 'unitPriceMax')"
            />
          </div>
        </van-cell>

        <van-cell title="激活数">
          <div slot="default" class="range-inputs">
            <van-field
              v-model="parameter.conversionMin"
              type="number"
              placeholder="最小值"
              @blur="validateRange('conversionMin', 'conversionMax')"
            />
            <span>~</span>
            <van-field
              v-model="parameter.conversionMax"
              type="number"
              placeholder="最大值"
              @blur="validateRange('conversionMin', 'conversionMax')"
            />
          </div>
        </van-cell>

        <van-cell title="转化成本">
          <div slot="default" class="range-inputs">
            <van-field
              v-model="parameter.conversionCostMin"
              type="number"
              placeholder="最小值"
              @blur="validateRange('conversionCostMin', 'conversionCostMax')"
            />
            <span>~</span>
            <van-field
              v-model="parameter.conversionCostMax"
              type="number"
              placeholder="最大值"
              @blur="validateRange('conversionCostMin', 'conversionCostMax')"
            />
          </div>
        </van-cell>

        <van-cell title="聚星订单">
          <van-field
            class="ipts"
            v-model="parameter.orderId"
            placeholder="请输入"
          />
        </van-cell>

        <van-cell title="助推订单">
          <van-field
            class="ipts"
            v-model="parameter.supplementOrderId"
            placeholder="请输入"
          />
        </van-cell>

        <van-cell title="投放人群">
          <selector-dropdown
            class="sca"
            v-model="parameter.targetType"
            :options="audience"
            placeholder="请选择"
            :clear-on-cancel="true"
          />
        </van-cell>

        <van-cell title="追投即将截止">
          <selector-dropdown
            class="sca"
            v-model="parameter.cutoff"
            :options="investment"
            placeholder="请选择"
            :clear-on-cancel="true"
          />
        </van-cell>

        <van-cell title="操作系统">
          <selector-dropdown
            class="sca"
            v-model="parameter.platform"
            :options="machinery"
            placeholder="请选择"
            :clear-on-cancel="true"
          />
        </van-cell>

        <van-cell title="效果日期">
          <date-range-picker
            class="box"
            v-model="dateRange"
            @change="handleDateChange"
          />
        </van-cell>

        <van-cell title="助推开始时间">
          <date-range-picker
            class="box"
            v-model="beginsRange"
            @change="handleBeginsChange"
          />
        </van-cell>

        <van-cell title="助推结束时间">
          <date-range-picker
            class="box"
            v-model="EndRange"
            @change="handleEndChange"
          />
        </van-cell>
      </div>

      <div class="filter-footer">
        <van-button plain @click="showMoreFilters = false">取消</van-button>
        <van-button type="primary" color="#2575F2" @click="applyFilters">
          确认
        </van-button>
      </div>
    </van-popup>

    <!-- 查看详情 -->
    <van-popup
      v-model="showDetailPopup"
      position="right"
      class="detail-popup"
      :style="{ width: '100%', height: '100%' }"
    >
      <div class="detail-header">
        <van-nav-bar
          title="订单详情"
          left-text="返回"
          left-arrow
          @click-left="showDetailPopup = false"
        />
      </div>
      <div class="detail-content">
        <p>助推订单：{{ currentDetail.supplementOrderId }}</p>
        <p>星视频订单：{{ currentDetail.orderId }}</p>
        <p>账户：{{ currentDetail.advertiserId }}</p>
        <p>暗户ID：{{ currentDetail.manualAccountId }}</p>
        <p>产品：{{ currentDetail.productName }}</p>
        <p>达人名称：{{ currentDetail.starName }}</p>
        <p>
          视频链接：
          <a :href="currentDetail.videoUrl" target="_blank">
            {{ currentDetail.videoUrl }}
          </a>
        </p>
        <p>
          优化目标：{{
            currentDetail.unitChargeType == "104"
              ? "激活数"
              : currentDetail.unitChargeType == "105"
              ? "行为数"
              : currentDetail.unitChargeType == "121"
              ? "付费"
              : ""
          }}
        </p>
        <p>
          深度优化目标：{{
            currentDetail.deepUnitChargeType == "0"
              ? "无"
              : currentDetail.deepUnitChargeType == "7"
              ? "自然日次日留存"
              : ""
          }}
        </p>
        <p>深度出价：{{ currentDetail.deepUnitPrice }}</p>
        <p>
          投放人群：{{
            currentDetail.targetType == "1"
              ? "智能"
              : currentDetail.targetType == "2"
              ? "自定义"
              : ""
          }}
        </p>
        <p>
          操作系统：{{
            currentDetail.platform == "0"
              ? "不限"
              : currentDetail.platform == "1"
              ? "IOS"
              : currentDetail.platform == "2"
              ? "安卓"
              : ""
          }}
        </p>
        <p>推广时长：{{ currentDetail.promotionDuration }}</p>
        <p>推广开始时间：{{ currentDetail.uploadDate }}</p>
        <p>推广结束时间：{{ currentDetail.finishDate }}</p>
        <p>
          推广剩余时间：{{ formatRemainingTime(currentDetail.remainingDate) }}
        </p>
        <p>
          投放剩余时间：{{ formatRemainingTime(currentDetail.circulationDate) }}
        </p>
        <p>
          追投即将截止：{{
            currentDetail.cutoff == "0"
              ? "否"
              : currentDetail.cutoff == "1"
              ? "是"
              : ""
          }}
        </p>
        <p>状态：{{ getStatusText(currentDetail.supplementOrderType) }}</p>
        <p>预警状态：{{ currentDetail.warningStatus }}</p>
        <p>预警值：{{ currentDetail.forewarning }}</p>
      </div>
    </van-popup>

    <budget-dialog ref="budgetDialog" @refresh="searchCriteria" />
  </div>
</template>

<script>
import PickerSelector from "@/components/PickerSelector.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import SelectorDropdown from "@/components/SelectorDropdown.vue";
import BudgetDialog from "./BudgetDialog.vue";
import { ProductData, AccountData } from "@/api/modules/home";
import {
  getBoostList,
  Dictionary,
  EndBoost,
  CancelBoostsOrder,
} from "@/api/modules/boost";

export default {
  name: "BoostOrdersPage",
  components: {
    PickerSelector,
    DateRangePicker,
    SelectorDropdown,
    BudgetDialog,
  },
  data() {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const todayStr = formatDate(today);
    return {
      showBudgetDialog: false,
      currentTitle: "助推订单",
      allProducts: [],
      allAdvert: [],
      dateRange: {
        startDate: todayStr,
        endDate: todayStr,
      },
      beginsRange: {
        startDate: null,
        endDate: null,
      },
      EndRange: {
        startDate: null,
        endDate: null,
      },
      parameter: {
        pageNo: 1,
        pageSize: 50,
        productId: "",
        advertiserId: "",
        orderId: "",
        supplementOrderId: "",
        orderBy: "",
        supplementOrderType: "1",
        deepUnitChargeType: "",
        targetType: "",
        cutoff: "",
        platform: "",
        consumeStartDateEnd: todayStr,
        consumeEndDateEnd: todayStr,
        startDateCreate: null,
        endDateCreate: null,
        startDateEnd: null,
        endDateEnd: null,
        circulationDateStart: null,
        circulationDateEnd: null,
        consumeAmountMin: null,
        consumeAmountMax: null,
        unitPriceMin: null,
        unitPriceMax: null,
        conversionMin: null,
        conversionMax: null,
        conversionCostMin: null,
        conversionCostMax: null,
      },
      SortValuesA: "",
      SortValuesB: "",

      // 更多筛选条件
      showMoreFilters: false,
      selectedCount: 0,
      remainingTimeMax: "",
      remainingTimeMin: "",

      invest: "1",
      option1: [
        { name: "小时", value: "1" },
        { name: "天", value: "0" },
      ],

      // 列表相关
      list: [],
      loading: false,
      finished: false,
      selectedItems: [],
      selectedItemsData: [], // 选中完整数据
      onAll: false, // 是否全选
      // 分页相关
      totalCount: 0,
      totalPages: 1,
      pageSizeOptions: [
        { text: "20条/页", value: 20 },
        { text: "50条/页", value: 50 },
        { text: "100条/页", value: 100 },
        { text: "200条/页", value: 200 },
        { text: "500条/页", value: 500 },
      ],

      // 新增详情弹窗相关数据
      showDetailPopup: false,
      currentDetail: {},
      stateDict: [],

      sortOptions: [
        { label: "默认", field: "" },
        { label: "消耗进度", field: "consume_amount_percent" },
        { label: "消耗金额", field: "consume_amount" },
        { label: "激活数", field: "conversion" },
        { label: "推广剩余时间", field: "remaining_date" },
      ],
      currentSort: {
        field: "", // 默认按消耗进度
        order: "", // 默认降序 desc、asc
      },
      StatusData: [
        { label: "定时中", value: "7" },
        { label: "待投放", value: "3" },
        { label: "待送审", value: "10" },
        { label: "推广中", value: "1" },
        { label: "推广完成", value: "2" },
        { label: "审核未通过", value: "11" },
      ],
      OrderType: [
        { label: "未知", value: "0" },
        { label: "人工创建", value: "2" },
        { label: "系统创建", value: "1" },
      ],
      optGoal: [
        { name: "无", value: "0" },
        { name: "自然日次日留存", value: "7" },
      ],
      optionss: [
        { text: "无", value: "0" },
        { text: "自然日次日留存", value: "7" },
        { text: "取消", value: "" },
      ],
      audience: [
        { name: "智能", value: "1" },
        { name: "自定义", value: "2" },
      ],
      investment: [
        { name: "是", value: "1" },
        { name: "否", value: "0" },
      ],
      machinery: [
        { name: "不限", value: "0" },
        { name: "IOS", value: "1" },
        { name: "安卓", value: "2" },
      ],
      offsetTop: "46px",
    };
  },
  computed: {
    // offsetTop() {
    //   return "46px";
    // },
  },
  async created() {
    this.getDeviceType();
    await this.loadProducts(); // 加载产品数据
    await this.getDict();

    await this.fetchListData();
  },
  methods: {
    getDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      // 判断是否是 iPad
      if (/ipad/i.test(userAgent)) {
        this.offsetTop = "94px";
      }
      // 判断是否是手机
      if (/iphone|ipod|android.*mobile/i.test(userAgent)) {
        this.offsetTop = "46px";
      }
      // 判断是否是 PC
      if (/windows|macintosh/i.test(userAgent)) {
        this.offsetTop = "125px";
      }
    },
    async getDict() {
      const res = await Dictionary({
        dictType: "ks_supplement_order_type_dict",
      });
      this.stateDict = res.map((item) => ({
        value: item.dictValue,
        label: item.dictLabel,
      }));
    },
    getStatusText(type) {
      const matched = this.stateDict.find((item) => item.value === type);
      return matched ? matched.label : "";
    },
    // 格式化剩余时间显示
    formatRemainingTime(hours) {
      if (!hours) return "0小时";
      if (hours > 24) {
        return `${Math.floor(hours / 24)}天${hours % 24}小时`;
      }
      return `${hours}小时`;
    },
    // 验证范围值，确保最小值不大于最大值
    validateRange(minField, maxField) {
      if (
        this.parameter[minField] &&
        this.parameter[maxField] &&
        Number(this.parameter[minField]) > Number(this.parameter[maxField])
      ) {
        this.$toast("最小值不能大于最大值");
        this.parameter[maxField] = this.parameter[minField];
      }
    },
    updateOffsetTop() {
      const viewportWidth = window.innerWidth;
      this.computedOffsetTop = (46 / viewportWidth) * 100;
    },
    // 获取产品
    async loadProducts() {
      const res = await ProductData({
        pageNo: 1,
        pageSize: 9999,
      });
      this.allProducts = res.map((item) => ({
        label: item.productName,
        value: item.id,
      }));
    },
    // 产品选择处理
    async handleProductSelect(id) {
      this.parameter.productId = id;
      this.parameter.advertiserId = "";
      this.allAdvert = [];
      if (id) {
        const res = await AccountData({
          productId: id,
          dataType: "1",
        });
        this.allAdvert = res.list.map((item) => ({
          label: item.advertiserId,
          value: item.advertiserId,
        }));
      }

      this.searchCriteria(); // 产品变化后触发查询
    },

    // 指标排序
    handleSort(field) {
      // 取消排序
      if (field === "") {
        this.currentSort.field = "";
        this.currentSort.order = "";
        this.parameter.orderBy = "";
        this.searchCriteria(); // 重新查询
        return;
      }

      if (this.currentSort.field === field) {
        this.currentSort.order =
          this.currentSort.order === "desc" ? "asc" : "desc";
      } else {
        this.currentSort.field = field;
        this.currentSort.order = "desc";
      }

      this.parameter.orderBy = `${this.currentSort.field} ${this.currentSort.order}`;
      this.searchCriteria();
    },

    // 账户处理
    handleAdvertSelect(id) {
      this.parameter.advertiserId = id;
      this.searchCriteria(); // 账户变化后触发查询
    },
    // 效果日期
    handleDateChange(range) {
      this.parameter.consumeStartDateEnd = range.startDate;
      this.parameter.consumeEndDateEnd = range.endDate;
    },
    // 助推开始时间
    handleBeginsChange(range) {
      this.parameter.startDateCreate = range.startDate;
      this.parameter.endDateCreate = range.endDate;
    },
    // 助推结束时间
    handleEndChange(range) {
      this.parameter.startDateEnd = range.startDate;
      this.parameter.endDateEnd = range.endDate;
    },

    // 获取列表数据
    async fetchListData() {
      try {
        this.parameter.productIds = this.parameter.productId
          ? [this.parameter.productId]
          : [];
        this.parameter.advertiserIds = this.parameter.advertiserId
          ? [this.parameter.advertiserId]
          : [];

        const res = await getBoostList(this.parameter);
        this.list = res.list || [];
        this.totalCount = res.count || 0;
        this.totalPages = Math.ceil(this.totalCount / this.parameter.pageSize);
        this.currentTitle = `助推订单 (${res.count || 0})`;
      } finally {
        this.finished = true;
        this.loading = false; // 关键：在这里设置
      }
    },

    // 处理页码变化
    prevPage() {
      if (this.parameter.pageNo > 1) {
        this.handlePageChange(this.parameter.pageNo - 1);
      }
    },
    nextPage() {
      if (this.parameter.pageNo < this.totalPages) {
        this.handlePageChange(this.parameter.pageNo + 1);
      }
    },
    handlePageChange(page) {
      this.parameter.pageNo = page;
      this.handleQuery();
    },
    handlePageSizeChange(e) {
      this.parameter.pageSize = e.target.value;
      this.searchCriteria();
    },

    // 条件筛选
    async searchCriteria() {
      this.parameter.pageNo = 1;
      await this.handleQuery();
    },

    // 刷新列表数据
    async handleQuery() {
      // 清空列表
      this.list = [];
      this.currentTitle = "助推订单";
      this.finished = false;
      this.loading = true;
      this.selectedItems = [];
      this.selectedItemsData = [];
      this.selectedCount = 0;
      await this.fetchListData();

      this.$nextTick(() => {
        this.onAll = false;
      });
    },

    // 应用筛选
    applyFilters() {
      if (this.invest === "0") {
        this.parameter.circulationDateStart = this.remainingTimeMin
          ? Number(this.remainingTimeMin) * 24
          : null;
        this.parameter.circulationDateEnd = this.remainingTimeMax
          ? Number(this.remainingTimeMax) * 24
          : null;
      } else {
        this.parameter.circulationDateStart = this.remainingTimeMin
          ? Number(this.remainingTimeMin)
          : null;
        this.parameter.circulationDateEnd = this.remainingTimeMax
          ? Number(this.remainingTimeMax)
          : null;
      }
      this.showMoreFilters = false;
      this.searchCriteria();
    },

    // 切换选择项
    toggleSelect(id) {
      const index = this.selectedItems.indexOf(id);
      if (index === -1) {
        this.selectedItems.push(id);
      } else {
        this.selectedItems.splice(index, 1);
      }
      this.selectedItemsData = this.list.filter((item) =>
        this.selectedItems.includes(item.supplementOrderId),
      );

      this.selectedCount = this.selectedItems.length;
      this.onAll = this.selectedItems.length === this.getSelectableCount();
    },

    // 全选操作
    handelselectAll(checked) {
      if (checked) {
        const selectableItems = this.list.filter(
          (item) => item.createType !== "系统创建",
        );
        this.selectedItems = selectableItems.map(
          (item) => item.supplementOrderId,
        );
        this.selectedItemsData = [...selectableItems];
      } else {
        if (this.selectedItems.length === this.getSelectableCount()) {
          this.selectedItems = [];
          this.selectedItemsData = [];
        }
      }

      this.selectedCount = this.selectedItems.length;
      this.onAll = this.selectedItems.length === this.getSelectableCount();
    },

    // 获取可选数量
    getSelectableCount() {
      return this.list.filter((item) => item.createType !== "系统创建").length;
    },

    // 批量按钮
    async handleActions(sift) {
      if (this.selectedItems.length === 0) {
        this.$toast("请选择至少一条订单！");
        return;
      }
      // 调用弹窗组件的方法
      this.$refs.budgetDialog.openBudgetDialog(
        this.selectedItems, // 选中id合集
        this.selectedItemsData, // 选中数据合集
        sift, // 区分按钮
      );
    },
    // 单个修改出价
    handleModifyBid(a, item) {
      let arr = [];
      arr.push(item);
      this.$refs.budgetDialog.openBudgetDialog(item.supplementOrderId, arr, a);
    },
    // 结束助推
    handleResultBoost() {
      if (this.selectedItems.length === 0) {
        this.$toast("请选择至少一条订单！");
        return;
      }
      this.$dialog
        .confirm({
          title: "确定要结束推广吗",
          message: `结束推广后，该流量助推订单停止消耗并进行结算，未消耗金额返还账户，是否继续操作?`,
        })
        .then(async () => {
          let arr = [];
          this.selectedItemsData.forEach((item) => {
            let obj = {};
            obj.advertiserId = item.advertiserId;
            obj.supplementOrderId = item.supplementOrderId;
            arr.push(obj);
          });
          const res = await EndBoost(arr);
          if (res.result == "true") {
            this.$toast(res.message);
            this.searchCriteria();
          }
        })
        .catch(() => {
          // on cancel
        });
    },

    // 取消发送
    handelCancelSend() {
      if (this.selectedItems.length === 0) {
        this.$toast("请选择至少一条订单！");
        return;
      }
      this.$dialog
        .confirm({
          title: "取消发送",
          message: `是否确认取消定时发送?`,
        })
        .then(async () => {
          const filteredData = this.selectedItemsData.filter(
            (item) => item.supplementOrderType == 7,
          );
          const ids = filteredData.map((item) => item.id);

          console.log(ids, "取消发送的参数");
          const res = await CancelBoostsOrder({ ids: ids });
          if (res.result == "true") {
            this.$toast(res.message);
            this.searchCriteria();
          }
        });
    },

    // 查看详情
    viewDetails(item) {
      this.currentDetail = item;
      this.showDetailPopup = true;
    },
    // 复制
    // copyItem(item) {
    //   this.$router.push({
    //     name: "addBoost",
    //     query: {
    //       data: JSON.stringify(item),
    //     },
    //   });
    // },
  },
};
</script>
<style scoped lang="scss">
.dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .navbar::v-deep(.van-nav-bar__title) {
    margin-left: 10px;
  }
}
.fullPage {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 60px; // 为底部tabbar留出空间

  .container-wrapper {
    flex: 1;
    overflow-y: auto;

    .search-header {
      background: #fff;
      box-sizing: border-box;
      border-bottom: 1px solid #f5f5f5;
      flex-shrink: 0; // 防止被压缩
    }
    .list-scroll-area {
      flex: 1;
      padding: 0 6px;

      // 让 van-list 占满高度
      .van-list {
        min-height: 100%;
      }
      // 禁用背景色
      .system-create .booster-item {
        border: 1px solid #f0ecec;
        background: #f0ecec;
      }
    }
  }

  .pagination-wrapper {
    background: #fff;
    padding: 8px;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    flex-shrink: 0; // 防止被压缩
    .pagination-controls {
      display: flex;
      justify-content: center;
      span {
        padding: 4px 8px;
        box-sizing: border-box;
        display: inline-block;
      }
      .page-info {
        min-width: 40px;
      }
    }
    select {
      position: absolute;
      top: 11px;
      right: 10px;
    }
  }
}

.search-header {
  .header_sift {
    display: flex;
    justify-content: space-between;
    padding-left: 6px;
    box-sizing: border-box;
    .filtrate {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .fit_item {
        box-sizing: border-box;
        width: 24%;
      }
    }
    .fittles {
      color: #f5a550;
      font-family: Inter;
      font-size: 12px;
      width: 50px;
      text-align: right;
      padding-right: 4px;
    }
  }
  .sort-bar {
    display: flex;
    padding: 5px 6px;
    gap: 10px;
    overflow-x: auto;
    white-space: nowrap;
    .sort-item {
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 500;
      color: #333;
      display: inline-flex;
      padding: 5px 6px 5px 10px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #ddd;
      background: #fff;

      .sort-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 4px;
        img {
          width: 8px;
          height: 4px;
          margin: 1px 0;
        }
      }
    }
    .sort-item.active {
      border-color: #266eff;
    }
  }
  .ceiling {
    background: #ffffff;
    padding: 5px 6px;
    box-sizing: border-box;
    .action-buttons {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      justify-content: space-between;

      .van-button {
        font-size: 12px;
        height: 42px;
        min-width: 68px;
        padding: 0 5px;
        border-radius: 5px;
        color: #fff;
      }
      .van-button:first-child {
        background: #e86793;
      }
      .van-button:nth-child(2) {
        background: #739afd;
      }
      .van-button:nth-child(3) {
        background: #449e92;
      }
      .van-button:nth-child(4) {
        background: #d498ef;
      }
      .van-button:nth-child(5) {
        background: #d99555;
      }
    }
    .selection-status {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      padding: 0 3px;
      box-sizing: border-box;
    }
  }
  .van-button--mini {
    height: 22px;
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
  }

  .enter-input {
    width: 101%;
    height: 22px;
    border-radius: 2px;
    border: 1px solid #ded9d9;
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    align-items: center;
    margin: 5px 0;
    padding: 0 10px;
    box-sizing: border-box;
  }
}

.sort-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.sort-row span {
  margin-right: 8px;
  font-size: 14px;
}

.sort-row .van-icon {
  margin-right: 8px;
}

.sort-row .van-button {
  margin-right: 8px;
}

.van-swipe-cell {
  border-radius: 4px;
  padding-top: 6px;

  &.selected {
    .booster-item {
      background-color: #f0f7ff;
      border: 1px solid #1989fa;
    }
  }
  .van-button {
    width: 52px;
    height: 100%;
    border-radius: 2px;
    margin-left: 6px;
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
    padding: 0;
    border: none;
  }
}

.booster-item {
  padding: 8px 5px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #f0ecec;
  position: relative;
  .item-header {
    position: absolute;
    top: -6px;
    left: 5px;
    padding: 1px 4px;
    box-sizing: border-box;
    background: #7eaffb;
    border-radius: 2px;
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
  }
  .item-stats {
    display: flex;
    flex-wrap: wrap;
    span {
      width: 40%;
      font-family: Inter;
      font-weight: 400;
      font-size: 10px;
      color: #000000;
      margin: 5px 0;
    }
    span:nth-child(2n) {
      width: 60%;
    }
  }
  .special-time {
    display: flex;
    span {
      width: 20%;
      font-family: Inter;
      font-weight: 400;
      font-size: 10px;
      color: #000000;
      margin: 5px 0;
    }
  }
}
.button-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.filter-popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1),
    0px 0px 6px 0px rgba(0, 0, 0, 0.09), 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px 12px 0px 0px;
  .filter-header {
    width: 100%;
    padding: 10px 0;
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    line-height: 12px;
    text-align: center;
  }

  .filter-content {
    margin-top: 3px;
    flex: 1;
    overflow-y: auto;
    .van-cell {
      padding: 3px 20px;
      border-bottom: none;
      align-items: center;
      .van-cell__title {
        width: 20%;
        font-family: Inter;
        font-weight: 400;
        font-size: 10px;
        color: #000000;
        flex: none;
        margin-right: 11px;
      }
    }
    .van-cell::after {
      border-bottom: none;
    }
    .range-inputs {
      display: flex;
      align-items: center;
      text-align: center;
      .van-field {
        padding: 0;
        width: 59px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #ded9d9;
        font-family: Inter;
        font-weight: 400;
        font-size: 10px;
        color: #8b8888;
        ::v-deep(.van-field__control) {
          text-align: center;
        }
      }
      span {
        margin: 0 6px;
      }
    }
    .advert {
      width: 59px;
      margin-left: 3px;
    }
    .box {
      width: 249px;
    }
    .sca {
      width: 177px;
    }
    .ipts {
      width: 179px;
      height: 24px;
      padding: 0 10px;
      border-radius: 2px;
      border: 1px solid #ded9d9;
      font-family: Inter;
      font-size: 10px;
      color: #8b8888;
    }
  }

  .filter-footer {
    display: flex;
    justify-content: space-around;
    padding: 15px;
    z-index: -1;
    .van-button {
      width: 85px;
      height: 22px;
      line-height: 22px;
      border-radius: 2px;
      font-size: 12px;
    }
    .van-button--plain {
      border: 1px solid #d4d0d0;
    }
  }
}
.detail-popup {
  .detail-header {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .detail-content {
    padding: 10px 15px;
    box-sizing: border-box;
    height: calc(100% - 46px);
    overflow-y: auto;

    p {
      padding: 0;
      margin: 0;
      margin-bottom: 15px;
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      line-height: 14px;
      a {
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
        color: #2575f2;
        text-decoration: underline;
      }
    }
  }
}
// 自封组件 样式修改
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0;
}
::v-deep .picker-selector .selector-input {
  border-color: #f1f5f8;
}
::v-deep .picker-selector .selector-input,
::v-deep .picker-selector .selector-input .van-cell {
  background: #f1f5f8;
  color: #000;
  font-family: "PingFang SC";
  font-weight: 500;
}
</style>
